import type { ReactNode } from 'react';

export const symbol_unarchive: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M501.5-287.63q8.5-8.62 8.5-21.37v-171l66 66q7.82 8 19.91 8t20.09-7.86q8-7.85 8-20 0-12.14-8-20.14L501-569q-9-9-21-9t-21 9L344-454q-8 7.82-8 19.91t7.86 20.09q7.85 8 20 8 12.14 0 20.14-8l66-66v171q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63ZM180-674v494h600v-494H180Zm0 554q-24.75 0-42.37-17.63Q120-155.25 120-180v-529q0-9.88 3-19.06 3-9.18 9-16.94l52-71q8-11 20.94-17.5Q217.88-840 232-840h495q14.12 0 27.06 6.5T775-816l53 71q6 7.76 9 16.94 3 9.18 3 19.06v529q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm17-614h565l-36.41-46H233l-36 46Zm283 307Z"
		/>
	</svg>
);
